import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmationResult } from '../../../../../shared/objects/enum/confirm-result';

@Component({
    selector: 'cp-generic-confirmation',
    templateUrl: './generic-confirmation.component.html',
    styleUrls: ['./generic-confirmation.component.scss'],
    standalone: false
})
export class GenericConfirmationComponent implements OnInit {

  @Input() title: string;
  @Input() textToDisplay: string;
  @Input() confirmButtonText: string;
  @Input() declineButtonText: string;
  @Output() optionChoosed: EventEmitter<ConfirmationResult>;

  constructor() {
    this.optionChoosed = new EventEmitter<ConfirmationResult>();
  }

  ngOnInit() {
  }

  confirmed() {
    this.optionChoosed.next(ConfirmationResult.Confirmed);
  }
  declined() {
    this.optionChoosed.next(ConfirmationResult.Declined);
  }
}
